import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SalesService } from '../../../../services/sales.service';
import { AgentUtility } from "../../../../util";
import {Agent, Role, Status, Permission} from '../../../../models';
import { MySalesComponent } from '../../my-sales.component';
import {BsModalComponent} from 'ng2-bs3-modal/ng2-bs3-modal';
import {AppSettings} from '../../../../app.settings';
import {Http, Response, RequestOptions, Headers, URLSearchParams} from '@angular/http';
import {HttpService, LogService} from '../../../../services';
import { SSOUtility } from "../../../../util/sso.utility";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css'],
  providers:[HttpService, SalesService, MySalesComponent]
})
export class UserInfoComponent implements OnInit {

  @Input() userInfo: Agent = new Agent();
  user_photo: SafeResourceUrl;
  @ViewChild('userPhotoModal',{static: false}) userPhotoModal: BsModalComponent;


  constructor(private salesService:SalesService, private mySalesComponent: MySalesComponent, 
    private http: Http,
    private httpService: HttpService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {
    
  }

  open() {
    this.userPhotoModal.open();
  }

  close() {
    this.userPhotoModal.close();
  } 

  getUserImg(){
    if(this.getUser().PhotoURL){
      var url = "https://" + location.hostname + ":" + AppSettings.portApi + "/" + this.getUser().PhotoURL;
      this.user_photo = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      return this.sanitizer.sanitize(5, this.user_photo);
    }
    else{
      var url = "https://" + location.hostname + ":" + AppSettings.portApi + "/" + 'user_default.png';
      this.user_photo = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      return this.sanitizer.sanitize(5, this.user_photo);      
    }
  }

  save(obj: any) {
    
    this.uploadFile(obj.target.files[0]).then(resp => {
        let respJson = resp.json();
        if (respJson.status == 'OK') {
            let agentId = this.getUser().Id;
            if (!isNaN(agentId) && agentId > 0) {
                this.httpService.getAgent(agentId)
                    .subscribe((data) => {
                        localStorage.setItem('user', JSON.stringify(data))
                    });
            }
        }
        alert(respJson.msg);
    });
  }

  uploadFile(file: File): Promise<any> {
    return SSOUtility.refreshToken().then(
      () =>{
        let token = 'Bearer '+ AgentUtility.getToken();
        let formData = new FormData();
        let headers = new Headers();
        headers.append("Authorization", token);
        let options = new RequestOptions({headers: headers});
        formData.append('avatar', file, file.name);
        return this.http.post(AppSettings.apiUrl + 'users/upload', formData, options).toPromise();
      }
    )
  }

  getUser(): any {
    let user = AgentUtility.getUser();
    return user;
  }



}
